import { render, staticRenderFns } from "./DashboardProductStatusNewSku.vue?vue&type=template&id=ef7d62aa&scoped=true&"
import script from "./DashboardProductStatusNewSku.vue?vue&type=script&lang=js&"
export * from "./DashboardProductStatusNewSku.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProductStatusNewSku.vue?vue&type=style&index=0&id=ef7d62aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d62aa",
  null
  
)

export default component.exports